import {
  Box,
  Button,
  Card,
  DropZone,
  FormLayout,
  InlineStack,
  Thumbnail,
} from "@shopify/polaris";
import { PlusIcon } from "@shopify/polaris-icons";

const BundleImages = ({
  handleAdditionalImagesDrop,
  editable,
  coverImage,
  handleCoverImageRemove,
  handleCoverImageDrop,
  additionalImages,
  handleRemoveAdditionalImage,
}) => {
  const coverImageUpload = !coverImage && (
    <DropZone.FileUpload
      actionHint={
        <>
          Min. image size 500px X 500px <br />
          Supported file formatsc: JPEG, JPG, PNG
        </>
      }
    />
  );
  const additionalImageUpload = !additionalImages.length && (
    <DropZone.FileUpload
      actionHint={
        <>
          Min. image size 500px X 500px <br />
          Supported file formats: JPEG, JPG, PNG
        </>
      }
    />
  );
  return (
    <Card sectioned>
      <FormLayout>
        <Box>
          <DropZone
            labelAction={"Drop an image"}
            // overlayText=""
            label="Bundle Cover Image"
            accept="image/*"
            type="image"
            onDrop={handleCoverImageDrop}
            allowMultiple={false}
            disabled={!editable}
          >
            {coverImageUpload}
            {coverImage ? (
              coverImage.url ? (
                <Box>
                  <div
                    onClick={(e) => {
                      // e.stopPropagation();
                      window.open(
                        coverImage.url,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                  >
                    <Thumbnail
                      source={coverImage.url}
                      alt="Cover Photo"
                      size="large"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(
                          URL.createObjectURL(coverImage.url),
                          "_blank"
                        );
                      }}
                    />
                  </div>
                  <Button disabled={!editable} onClick={handleCoverImageRemove}>
                    Remove
                  </Button>
                </Box>
              ) : (
                <Box>
                  <Thumbnail
                    source={URL.createObjectURL(coverImage)}
                    alt="Cover Photo"
                    size="large"
                    onClick={() =>
                      window.open(URL.createObjectURL(coverImage), "_blank")
                    }
                  />
                  <Button disabled={!editable} onClick={handleCoverImageRemove}>
                    Remove
                  </Button>
                </Box>
              )
            ) : (
              <DropZone.FileUpload />
            )}
          </DropZone>
        </Box>
        <Box>
          <DropZone
            label="Bundle Media (up to 5)"
            accept="image/*"
            type="image"
            onDrop={handleAdditionalImagesDrop}
            disabled={!editable}
          >
            {additionalImageUpload}
            <InlineStack gap="500" align="start">
              {additionalImages.map((file, index) => (
                <Box key={index} display="inline-block">
                  {file.url ? (
                    <Thumbnail
                      source={file.url}
                      alt={`Image ${index + 1}`}
                      size="large"
                    />
                  ) : (
                    <Thumbnail
                      source={URL.createObjectURL(file)}
                      alt={`Image ${index + 1}`}
                      size="large"
                    />
                  )}
                  <Button
                    plain
                    destructive
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveAdditionalImage(index);
                    }}
                    disabled={!editable}
                    size="micro"
                  >
                    Remove
                  </Button>
                </Box>
              ))}
              {additionalImages.length < 5 ? (
                <Box display="inline-block">
                  <Thumbnail source={PlusIcon} alt="Add more" size="large" />
                </Box>
              ) : (
                ""
              )}
            </InlineStack>
          </DropZone>
        </Box>
      </FormLayout>
    </Card>
  );
};
export default BundleImages;
